// Export to Excel Component. Uses the 'xlsx' library to convert JSON data to an Excel file and trigger a download.
// This component is used in the Reports page to allow users to export report data.
// It also used file-saver to handle the file download in the browser.
// Uses a simple table download from react-export-table-to-excel library
// because XLSX library does export tables.
import React from 'react';
import styles from '../css/reports.module.css';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { FaFileExcel } from 'react-icons/fa6';

function ExportToExcelComponent({ data, targetTableRef, reportName }) {
  const { onDownload } = useDownloadExcel({
    currentTableRef: targetTableRef.current,
    filename: reportName,
    sheet: reportName + 'Sheet',
  });

  // if (data.length === 0) {
  //   alert('No data available to export.');
  //   return;
  // }

  return (
    <div>
      <button className={styles.reportButton} onClick={onDownload}>
        <FaFileExcel
          size={20}
          style={{
            marginRight: '5px',
            paddingBottom: '3px',
            color: 'white',
            fontSize: '18px',
            verticalAlign: 'middle',
          }}
        />
        Export to Excel
      </button>
    </div>
  );
}

export default ExportToExcelComponent;
